import 'styles/components/from-manager-list.scss'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import From from 'entities/mail_from'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'
import FromListItem from './from_list_item'
import FromListNew from './from_list_new'

export default class FromSelector extends Component {
  constructor(props) {
    super(props)

    this.state = {
      froms: props.froms.map(f => new From(f)),
      selectedId: props.selectedId,
      show: false
    }
  }

  showList() {
    this.setState({
      show: true
    })
  }

  hideList() {
    this.setState({
      show: false
    })
  }

  handleSelectFrom(from) {
    this.setState({
      selectedId: from.id,
      show: false
    })
  }

  handleCreateFrom(from) {
    const { froms: currentFroms } = this.state
    const froms = [...currentFroms, from]

    this.setState({
      froms
    })
  }

  handleUpdateFrom(from) {
    const { froms: currentFroms } = this.state
    const froms = currentFroms.map(f => (f.id === from.id ? from : f))

    this.setState({
      froms
    })
  }

  handleDeleteFrom(from) {
    const { froms: currentFroms } = this.state
    const froms = currentFroms.filter(m => m.id !== from.id)

    this.setState({
      froms
    })
  }

  renderFromsList() {
    const { froms, show } = this.state
    const {
      mail_froms_creatable: mailFromsCreatable,
      mail_froms_updatable: mailFromsUpdatable,
      mail_froms_deletable: mailFromsDeletable
    } = this.props

    if (!show) {
      return null
    }

    const fromListItems = froms.map(from => (
      <FromListItem
        key={from.id}
        from={from}
        updatable={mailFromsUpdatable}
        deletable={mailFromsDeletable}
        onSelectFrom={newFrom => this.handleSelectFrom(newFrom)}
        onUpdateFrom={newFrom => this.handleUpdateFrom(newFrom)}
        onDeleteFrom={newFrom => this.handleDeleteFrom(newFrom)}
      />
    ))

    const fromListNew = mailFromsCreatable ? (
      <FromListNew onCreateFrom={newFrom => this.handleCreateFrom(newFrom)} />
    ) : null

    return (
      <div className="from-selector">
        <div className="from-selector-bg" onClick={() => this.hideList()} role="presentation" />
        <div className="from-selector-list">
          <div className="from-selector-list-items">
            {fromListNew}
            {fromListItems}
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { paramKey } = this.props
    const { show, froms, selectedId } = this.state
    const className = classnames('btn-selector', {
      'is-active': show
    })
    const from = froms.find(f => f.id === selectedId) || null
    const name = from !== null ? `"${from.name}" <${from.email}>` : null
    const hiddenField = from !== null ? <input type="hidden" name={`${paramKey}[from_id]`} value={from.id} /> : null

    return (
      <div className="select-field">
        <button type="button" className={className} onClick={() => this.showList()}>
          {name || I18n.t('components.mail_from.from_selector.button.select')}
          <div className="caret" />
        </button>
        {hiddenField}
        {show ? this.renderFromsList() : null}
      </div>
    )
  }
}

FromSelector.propTypes = {
  froms: PropTypes.arrayOf(propTypeInstantiableTo(From)).isRequired,
  paramKey: PropTypes.string.isRequired,
  selectedId: PropTypes.number,
  mail_froms_creatable: PropTypes.bool.isRequired,
  mail_froms_updatable: PropTypes.bool.isRequired,
  mail_froms_deletable: PropTypes.bool.isRequired
}

FromSelector.defaultProps = {
  selectedId: null
}
